import {createStateMaker} from '@shared/helpers/object'

import {MerchantsState} from '../interfaces'

export const getInitialState = (): MerchantsState => ({})

export const makeMock = createStateMaker<MerchantsState>(getInitialState)
